(function () {
  htmx.defineExtension("focus-selector", {
    onEvent: function (name, evt) {
      if (name !== "htmx:afterSettle") {
        return;
      }
      let focusTarget = evt.target.getAttribute("hx-set-focus");
      if (focusTarget === null) {
        return;
      }
      let ele = htmx.find(focusTarget);
      if (ele === undefined || ele === null) {
        return;
      }
      mrp.log("hx-set-target");
      ele.focus();
    },
  });
})();
